import { Equatable } from "@siteimprove/alfa-equatable";
import { Serializable } from "@siteimprove/alfa-json";
import { None, Option } from "@siteimprove/alfa-option";
/**
 * @public
 */
export class Right {
    static of(value) {
        return new Right(value);
    }
    _value;
    constructor(value) {
        this._value = value;
    }
    isLeft() {
        return false;
    }
    isRight() {
        return true;
    }
    map(mapper) {
        return new Right(mapper(this._value));
    }
    apply(mapper) {
        return mapper.map((mapper) => mapper(this._value));
    }
    flatMap(mapper) {
        return mapper(this._value);
    }
    flatten() {
        return this._value;
    }
    reduce(reducer, accumulator) {
        return reducer(accumulator, this._value);
    }
    either(left, right) {
        return right(this._value);
    }
    get() {
        return this._value;
    }
    left() {
        return None;
    }
    right() {
        return Option.of(this._value);
    }
    teeLeft() {
        return this;
    }
    teeRight(callback) {
        callback(this._value);
        return this;
    }
    equals(value) {
        return (value instanceof Right && Equatable.equals(value._value, this._value));
    }
    hash(hash) {
        hash.writeBoolean(true).writeUnknown(this._value);
    }
    *[Symbol.iterator]() {
        yield this._value;
    }
    toJSON() {
        return {
            type: "right",
            value: Serializable.toJSON(this._value),
        };
    }
    toString() {
        return `Right { ${this._value} }`;
    }
}
/**
 * @public
 */
(function (Right) {
    function isRight(value) {
        return value instanceof Right;
    }
    Right.isRight = isRight;
})(Right || (Right = {}));
//# sourceMappingURL=right.js.map